// Matomo auto-hébergé.
//
// L'app chargeait auparavant le conteneur Matomo Cloud
// (`cdn.matomo.cloud/9achna.matomo.cloud/container_….js`), écrit en dur dans
// App.js. Depuis la migration vers l'instance auto-hébergée ce conteneur ne
// répond plus : le suivi s'est arrêté sans erreur visible.
//
// ⚠️ Un CRA fige ses `REACT_APP_*` à la COMPILATION. Les variables doivent donc
// être présentes dans l'environnement de build de Railway, pas seulement au
// démarrage du serveur. Sans elles, le suivi est simplement désactivé — jamais
// d'erreur en console pour l'utilisateur.
const MATOMO_URL = process.env.REACT_APP_MATOMO_URL;
const SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID;

// L'URL doit finir par un slash : `${base}matomo.php` sinon on obtient une
// double barre, que certains proxys refusent.
const base = MATOMO_URL
  ? (MATOMO_URL.endsWith('/') ? MATOMO_URL : `${MATOMO_URL}/`)
  : null;

let started = false;

/** Injecte le tracker. Idempotent : appelable plusieurs fois sans risque. */
export function initMatomo() {
  if (started || !base || !SITE_ID) return;
  started = true;

  const _paq = (window._paq = window._paq || []);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  _paq.push(['setTrackerUrl', `${base}matomo.php`]);
  _paq.push(['setSiteId', String(SITE_ID)]);

  if (document.getElementById('matomo-tracker')) return;
  const g = document.createElement('script');
  g.id = 'matomo-tracker';
  g.async = true;
  g.src = `${base}matomo.js`;
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(g, s);
}

/**
 * Vue de page sur navigation interne. Le Tag Manager s'en chargeait tout seul ;
 * le tracker classique, non. Sans cet appel, seule la page d'entrée serait
 * comptée dans une application à navigation côté client.
 */
export function trackPageView() {
  if (!window._paq) return;
  window._paq.push(['setCustomUrl', window.location.href]);
  window._paq.push(['setDocumentTitle', document.title]);
  window._paq.push(['trackPageView']);
}

// Événements personnalisés
export function trackEvent(category, action, name) {
  if (!window._paq) return;
  window._paq.push(['trackEvent', category, action, name]);
}
